<template>
  <div style="display: contents">
    <!-- 右侧容器 - 固定模式（独立Web） -->
    <div
      v-show="
        $parent.isSmartMode &&
        ((!$parent.selectedAgent &&
          !$parent.useDrawer &&
          $parent.selectedCardId !== 'digital_plaza' &&
          $parent.selectedCardId !== 'agent_plaza' &&
          $parent.selectedCardId !== 'knowledge_base') ||
          ($parent.useDrawer && !$parent.hideSidebar && !$parent.isPlazaMode && $parent.clawMode !== 'assistant'))
      "
      id="right-sidebar-chat"
      class="right-sidebar"
    >
      <CosmoClawChat
        ref="rightSidebarChat"
        :key="$parent.sidebarKey"
        :mode="$parent.clawMode"
        @mode-change="$parent.handleClawModeChange"
      />
    </div>

    <!-- 右侧容器 - 抽屉模式（桌面端嵌入时） -->
    <el-drawer
      ref="drawer"
      v-if="
        $parent.isSmartMode &&
        $parent.useDrawer &&
        !$parent.hideSidebar &&
        !$parent.isPlazaMode &&
        !$parent.selectedAgent &&
        $parent.clawMode == 'assistant'
      "
      :visible="$parent.drawerVisible" @update:visible="$parent.drawerVisible = $event"
      :with-header="false"
      size="500px"
      :modal="false"
    >
      <div id="drawer-chat" class="drawer-chat-wrap">
        <CosmoClawChat
          ref="drawerChat"
          :mode="$parent.clawMode"
          style="flex: 1; min-height: 0; border-radius: 0; height: auto"
          @mode-change="$parent.handleClawModeChange"
        />
      </div>
    </el-drawer>

    <!-- 抽屉模式下最小化后的浮动箭头 -->
    <div
      v-show="
        $parent.isSmartMode &&
        $parent.useDrawer &&
        !$parent.isPlazaMode &&
        !$parent.selectedAgent &&
        $parent.clawMode == 'assistant'
      "
      class="drawer-mini-arrow"
      :key="$parent.windowWidth"
      @click="$parent.drawerVisible = true"
    >
      <i class="el-icon-arrow-left"></i>
    </div>
  </div>
</template>

<script>
import CosmoClawChat from './CosmoClawChat.vue'

export default {
  name: 'RightChatPanel',
  components: { CosmoClawChat }
}
</script>

<style lang="scss" scoped>
/* ========== 右侧边栏 ========== */
.right-sidebar {
  flex: 1;
  min-width: 0;
  background: rgba(255, 255, 255, 0.4);
  border: 1px solid #ffffff;
  border-left: none;
  border-radius: 0 8px 8px 0;
  padding: 10px;
  padding-left: 6px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
/* ========== 抽屉模式右侧吸附箭头 ========== */
.drawer-mini-arrow {
  position: fixed;
  top: 30%;
  right: 0;
  transform: translateY(-50%);
  z-index: 1000;
  width: 8px;
  height: 60px;
  border-radius: 4px 0 0 4px;
  background: #4a5ff3;
  color: #fff;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: -1px 0 4px rgba(74, 95, 243, 0.2);
  transition: all 0.2s ease;
}
.drawer-mini-arrow:hover {
  background: #3a4fd6;
}
/* 抽屉模式聊天容器 — 修复 drawer body overflow:auto 导致的高度计算问题 */
.drawer-chat-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.drawer-chat-wrap .cosmo-claw-chat {
  flex: 1;
  min-height: 0;
  border-radius: 0;
}
</style>
